import React from "react";
import { injectIntl } from "react-intl"
import Chart from 'react-apexcharts'
import { ApexOptions } from "apexcharts"

export interface PRecordedAlertsColumnChartData {
  categories: Array<string>
  values: Array<number>
}
export interface PRecordedAlertsColumnChartProps {
  intl: any
  data?: PRecordedAlertsColumnChartData
  width?: number
  height?: number
}
function RecordedAlertsColumnChart(props: PRecordedAlertsColumnChartProps) {
  const { data, width, height } = props

  const [options, setOptions] = React.useState<ApexOptions>({
    chart: {
      id: 'apexchart-example',
      toolbar: {
        show: false,
        tools: {
          download: false
        }
      }
    },
    title: {
      text: "Quantidade de Alertas de Decúbito (últimas 12 horas)",
      align: 'left',
      style: {
        color: "white"
      }
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      }
    },
    stroke:{
      colors:['#0000000']
     },
    colors:['#00E396D9', '#FEB019D9'],
    dataLabels: {

      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ["white"]
      }
    },
    xaxis: {
      categories: [],
      position: 'top',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      labels: {
        style: {
          colors: "white"
        }
      },
      crosshairs: {
        fill: {
          type: 'gradient',
          gradient: {
            colorFrom: '#D8E3F0',
            colorTo: '#BED1E6',
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          }
        }
      },
      tooltip: {
        enabled: true,
      }
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return `${val}`;
        }
      }
    }
  })

  const [dataSerie, setDataSerie] = React.useState<Array<number>>([])
  React.useEffect(() => {
    if (!data) {
      setDataSerie([])
      return
    }

    setOptions({
      ...options,
      ...{
        xaxis: {
          categories: data.categories
        }
      }
    })
    setDataSerie(data.values)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <Chart
      type="bar"
      options={options}
      series={[{
        name: 'records',
        data: dataSerie
      }]}
      width={width ?? '100%'}
      height={height ?? '100%'}
      />
  )
}
export default injectIntl((RecordedAlertsColumnChart))
